import React, { useState, useEffect } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { adminLogout , adminUpdatePassword } from '../redux/action/adminAction';

const Home = () => {
    const store = useSelector(store => store);
    const [name, setName] = useState("");
    const [isFacultyDropdownOpen, setIsFacultyDropdownOpen] = useState(false); // Toggle state for Faculty dropdown
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    
    const validatePassword = (password) => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        return passwordRegex.test(password);
    };
    
    const formHandler = (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
    
        // Validation for new password
        if (!validatePassword(newPassword)) {
            setError(
                'Password must be at least 8 characters long, include an uppercase letter, and a lowercase letter.'
            );
            return;
        }
    
        // Check if new password and confirmation match
        if (newPassword !== confirmNewPassword) {
            setError('New password and confirm password do not match.');
            return;
        }
    
        // Dispatch the action if validation passes
        dispatch(
            adminUpdatePassword({
                registrationNumber:store.admin.admin.registrationNumber,
                oldPassword,
                newPassword,
            })
        );
    
        // Set success message
        setMessage('Password updated successfully!');
    };
    
    useEffect(() => {
        if (store.admin?.admin?.name) {
            setName(store.admin.admin.name);
        }
    }, [store.admin?.admin?.name]);

    const history = useHistory();
    const dispatch = useDispatch();

    const logoutHandler = () => {
        dispatch(adminLogout());
        history.push('/adminLogin');
    };

    // Function to toggle the Faculty dropdown
    const toggleFacultyDropdown = () => {
        setIsFacultyDropdownOpen(!isFacultyDropdownOpen);
    };

    const colorConfigs = {
        sidebar: {
            bg: "#233044",
            color: "#eeeeee",
            hoverBg: "#1e293a",
            activeBg: "#1e253a"
        },
        topbar: {
            bg: "#fff",
            color: "#000"
        }
    };

    return (
        <div className='outer-div'>
            <div className='inner-div'>
                <div className="" >
                    <div style={{ height: '100dvh', backgroundColor: '#233044' }} className="navbar overflow-hidden p-0 flex-column navbar-expand-lg navbar-light text-light">
                        <button
                            className="navbar-toggler text-light"
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbarNav"
                            aria-controls="navbarNav"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <img src="/image/manu.svg" alt="" />
                        </button>
                        <div className="collapse navbar-collapse align-items-start w-100" id="navbarNav">
                            <ul className="navbar-nav  d-flex w-100 flex-column">
                                <div>
                                    <div className="col d-flex align-items-center justify-content-center flex-column">
                                        <img src="/logo512.png" className=" mt-1 nav-img" alt="" />
                                        <h6 className='text-center p-1' style={{ backgroundColor: '#1e253a' }}><b>ARJ COLLEGE OF ENGINEERING <br /> AND TECHNOLOGY</b></h6>
                                    </div>
                                </div>
                                <li className="nav-item">
                                    <NavLink
                                        to="/adminHome"
                                        activeClassName="active1"
                                        className="nav-link "
                                    >
                                        <span className='d-flex align-items-center justify-content-start'><img src="/image/user.svg" className='px-2' alt="" />
                                            <span className="notice-board">MY PROFILE</span> </span>
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink
                                        to="/admin/addNotice"
                                        activeClassName="active1"
                                        className="nav-link "
                                    >
                                        <span className='d-flex align-items-center justify-content-start'><img src="/image/Board.svg" className='px-2' alt="" />
                                            <span className="notice-board">NOTIC BOARD</span></span>
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink
                                        to="/admin/AdminGetAllAdmins"
                                        activeClassName="active1"
                                        className="nav-link "
                                    >
                                        <span className='d-flex align-items-center justify-content-start'><img src="/image/admin.svg" className='px-2' alt="" />
                                            <span className="notice-board">ADMIN CONTROL</span></span>
                                    </NavLink>
                                </li>
                                <li
                                    className={`nav-item dimanu ${isFacultyDropdownOpen ? 'active1' : ''}`} // Conditionally add the active1 class
                                >
                                    <div
                                        onClick={toggleFacultyDropdown}
                                        className="nav-link d-flex align-items-center justify-content-start"
                                        style={{
                                            cursor: "pointer",
                                        }}
                                    >
                                        <img src="/image/faculty.svg" className="px-2" alt="faculty icon" />
                                        <span className="notice-board">FACULTIES CONTROL</span>
                                        <i className={`ml-auto text-light dropdown-icon ${isFacultyDropdownOpen ? 'rotate' : ''}`}>
                                            &#9662;
                                        </i>
                                    </div>

                                    {/* Conditionally render the dropdown based on the toggle state */}
                                    {isFacultyDropdownOpen && (
                                        <ul className="pl-4" style={{ listStyleType: "none" }}>
                                            <li className="dropdown-item1">
                                                <NavLink
                                                    to="/admin/allFaculties"
                                                    className="ditem"
                                                >
                                                    Manage Faculties
                                                </NavLink>
                                            </li>
                                            <li className="dropdown-item1">
                                                <NavLink
                                                    to="/admin/addFaculty"
                                                    className="ditem"
                                                >
                                                    Add Faculty
                                                </NavLink>
                                            </li>
                                            <li className="dropdown-item1">
                                                <NavLink
                                                    to="/admin/FacultyTimeTable"
                                                    className="ditem"
                                                >
                                                    Faculty TimeTable
                                                </NavLink>
                                            </li>
                                        </ul>
                                    )}
                                </li>

                                <li className="nav-item">
                                    <NavLink
                                        to="/admin/allStudents"
                                        activeClassName="active1"
                                        className="nav-link "
                                    >
                                        <span className='d-flex align-items-center justify-content-start'><img src="/image/student.svg" width={'40px'} className='px-2' alt="" />
                                            <span className="notice-board">STUDENT CONTROL</span></span>
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink
                                        to="/admin/allSubject"
                                        activeClassName="active1"
                                        className="nav-link"
                                    >
                                        <span className='d-flex align-items-center justify-content-start'><img src="/image/subject.svg" width={'40px'} className='px-2' alt="" />
                                            <span className="notice-board">ACADEMIC'S</span></span>
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink
                                        to="/admin/AdminTransport"
                                        activeClassName="active1"
                                        className="nav-link"
                                    >
                                        <span className='d-flex align-items-center justify-content-start'><img src="/image/bus.svg" width={'40px'} className='px-2' alt="" />
                                            <span className="notice-board">STATISTICS</span></span>
                                    </NavLink>
                                </li>
                                <li className="nav-item p-2">
                                    <button style={{ listStyle: "None" }} onClick={logoutHandler} type="button" className="btn w-100 btn-danger text-light"><li>LOGOUT</li></button>
                                </li>
                                <li className="nav-item p-2">
                                    <button type="button" className=" btn-info w-100 mt-2 btn text-light" data-bs-toggle="modal" data-bs-target="#exampleModal"> <img src="/image/edit.svg" width={'16px'} alt="" /> Update Password</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div
            className="modal fade"
            id="exampleModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title fs-5" id="exampleModalLabel">
                            Update Password
                        </h5>
                    </div>
                    <div className="modal-body">
                        <form noValidate onSubmit={formHandler}>
                            <div className="mb-3">
                                <label htmlFor="oldPassword" className="form-label">
                                    Old Password
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="oldPassword"
                                    placeholder="Enter your old password"
                                    required
                                    value={oldPassword}
                                    onChange={(e) => setOldPassword(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="newPassword" className="form-label">
                                    New Password
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="newPassword"
                                    placeholder="Enter your new password"
                                    required
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="confirmNewPassword" className="form-label">
                                    Confirm Password
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="confirmNewPassword"
                                    placeholder="Enter confirm new password"
                                    required
                                    value={confirmNewPassword}
                                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                                />
                            </div>
                            <button type="submit" className="btn btn-success">
                                Update
                            </button>
                        </form>
                        {error && <div className="alert alert-danger mt-3">{error}</div>}
                        {message && <div className="alert alert-success mt-3">{message}</div>}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </div>



    )
}

export default Home

